import isEmpty from '../../../utils/isEmpty';

const getChargeData = (invoice) => {
	if (!invoice) return [];

	// Stripe responses can include either `charges.data` or `latest_charge`.
	if (invoice.charges && Array.isArray(invoice.charges.data)) {
		return invoice.charges.data;
	}

	if (
		invoice.latest_charge &&
		typeof invoice.latest_charge === 'object' &&
		!Array.isArray(invoice.latest_charge)
	) {
		return [invoice.latest_charge];
	}

	return [];
};

const getPrimaryCharge = (invoice) => {
	const chargeData = getChargeData(invoice);
	if (!isEmpty(chargeData)) return chargeData[0];
	return null;
};

const getBalanceTransaction = (invoice) => {
	const primaryCharge = getPrimaryCharge(invoice);
	if (
		primaryCharge &&
		primaryCharge.balance_transaction &&
		typeof primaryCharge.balance_transaction === 'object'
	) {
		return primaryCharge.balance_transaction;
	}
	return null;
};

export const determineRefund = (invoice) => {
	const chargeData = getChargeData(invoice);

	if (isEmpty(chargeData)) return undefined;

	const refundedAmount = chargeData.reduce(
		(total, charge) => total + (charge?.amount_refunded || 0),
		0
	);

	return refundedAmount > 0 ? refundedAmount : undefined;
};

export const determineStripeFee = (invoice) => {
	// Prefer Stripe's actual fee (in cents) when available.
	const balanceTransaction = getBalanceTransaction(invoice);
	if (
		balanceTransaction &&
		typeof balanceTransaction.fee === 'number'
	) {
		return balanceTransaction.fee;
	}

	// if there is not payment method don't bother trying to get the fee
	if (invoice.payment_method && invoice.payment_method.card) {
		const country = `${invoice.payment_method.card.country}D`;
		// Fallback estimate:
		// - same card-country + currency (e.g. CA card + CAD charge): 2.9% + 30 cents
		// - cross-border currency mismatch: 3.5% + 30 cents
		// Fallback only: estimate fee using current card pricing and round to cents.
		if (invoice.currency.toUpperCase() === country) {
			return Math.round(invoice.amount * 0.029 + 30);
		} else {
			return Math.round(invoice.amount * 0.035 + 30);
		}
	}

	return undefined;
};

export const determineNet = (invoice) => {
	let net = undefined;
	const refundedAmount = determineRefund(invoice);
	const fee = determineStripeFee(invoice);

	// if there is not payment method don't bother trying to get the net
	if (invoice.payment_method && typeof fee === 'number') {
		// Keep all math in cents to avoid float drift between fee and net.
		// if there has been refunds subtract them
		if (refundedAmount) {
			net = invoice.amount - fee - refundedAmount;
		} else {
			net = invoice.amount - fee;
		}
	}
	return net;
};
